import { Component, OnDestroy, OnInit, ViewChild, input } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, take } from 'rxjs';
import { GridColConfig } from 'src/app/core/custom-grid/custom-grid';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { GestionePartiteService } from '../gestione-partite/gestione-partite.service';
import { MissionDto } from '../gestione-partite/partite-dto';
import { CardSummarySinglelineComponent } from "src/app/core/card-summary-singleline/card-summary-singleline.component";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { GestioneMissioniService } from './gestione-missioni.service';
import { MatMenuModule } from '@angular/material/menu';
import { ToastService } from 'src/app/core/toast/toast.service';


@Component({
  selector: 'app-gestione-missioni',
  imports: [
    CardSummarySinglelineComponent,
    MatIconModule,
    MatButtonModule,
    MatMenuModule
  ],
  templateUrl: './gestione-missioni.component.html',
  styleUrl: './gestione-missioni.component.scss'
})
export class GestioneMissioniComponent implements OnInit, OnDestroy {

  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;
  readonly idAdventure = input.required<string>();

  options: GridColConfig[] = [];
  missioni: MissionDto[] = [];

  private theEnd$ = new Subject<void>();


  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private missionService: GestioneMissioniService,
    private toast: ToastService
  ) {
  }



  ngOnInit(): void { //TODO make lazy loading


    this.localstorage.setTitolo('Gestione missioni');

    this.getMissions();


    this.options = [
      {
        type: 'button',
        name: 'Modifica',
        field: 'none',
        icon: 'pencil',
        cssClass: 'edit-button',
        fieldOptions: {
        },
        width: '40'
      },
      {
        type: 'text',
        name: 'Nome',
        field: 'name',
        fieldOptions: {
        }
      },
      {
        type: 'text',
        name: 'Descrizione',
        field: 'description',
        fieldOptions: {
        }
      },
      {
        type: 'button',
        name: 'Elimina',
        field: 'none',
        icon: 'trash',
        cssClass: 'delete-button',
        fieldOptions: {
        },
        width: '40'
      }
    ];
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }


  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id)
    }
    if (event.action == 'elimina') {

      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }

  }

  getMissions(){
    this.missionService.getAllByAdventure(this.idAdventure()).pipe(take(1)).subscribe({
      next: (data: MissionDto[]) => {
        this.missioni = data;
      }
    })
  }

  unlockTypeToString(ut: string): string {
    switch (ut) {
      case 'gps': return 'GPS';
      case 'immediate': return 'Immediato';
      case 'time': return 'Tempo';
      case 'qr': return 'QR Code';
      default: return 'Immediato';
    }
  }

  edit(id: string): void {
    this.router.navigate([`/home/missioni-esplorative/${id}`]);
  }


  add(): void {
    this.router.navigate([`/home/missioni-esplorative/new`, this.idAdventure()]);
  }

  delete(id:string){
    this.missionService.delete(id).pipe(take(1)).subscribe({
      next:()=>{
        this.toast.success('Missione eliminata');
        this.getMissions();
      }
    })
  }



}
